export default "__VITE_ASSET__BfITQIJm__"